import React, { Suspense } from 'react';
import { Routes as RouterRoutes, Route, Navigate } from 'react-router-dom';
import { Path } from './Paths';
import LoadingIndicator from '../Common/LoadingIndicator';
import styled from 'styled-components';
import NotFound from '../Common/NotFound';
import DefaultLayout from './DefaultLayout';
import KeyboardInstallationGuide from '../KeyboardInstallationGuide';
import AndroidKeyboardInstallationGuide from '../AndroidKeyboardInstallationGuide';
import PartnerpluginsdkActivate from '../PartnerpluginsdkActivate';
import { ScrollToTop } from '../Common/ScrollToTop';
import { SamsungActivation } from '../Samsung';
import ExtensionInstalled from '../Extension/ExtensionInstalled';
import ExtensionUninstalled from '../Extension/ExtensionUninstalled';
import SamsungLanding from '../Samsung/SamsungLanding';
import TreePlanting from '../TreePlanting';
import ChromeDesktopUTMTracking from '../ChromeDesktopUTMTracking/ChromeDesktopUTMTracking';
import PartnerPluginActivateMultiStepAlwaysAllow from '../PartnerpluginsdkActivate/PartnerPluginActivateMultiStepAlwaysAllow';
import PartnerPluginActivateMultiStepAlmostThere from '../PartnerpluginsdkActivate/PartnerPluginActivateMultiStepAlmostThere';
import PartnerPluginActivateMultiStepBeSureToAllow from '../PartnerpluginsdkActivate/PartnerPluginActivateMultiStepBeSureToAllow';
import PartnerPluginActivateMultiStepStartShopping from '../PartnerpluginsdkActivate/PartnerPluginActivateMultiStepStartShopping';
import PartnerNewpluginsdkActivate from '../PartnerNewpluginsdkActivate';
import LinkRedirect from './LinkRedirect';
import PartnerNewPluginActivateMultiStepAlwaysAllow from '../PartnerNewpluginsdkActivate/PartnerNewPluginActivateMultiStepAlwaysAllow';
import PartnerNewPluginActivateMultiStepPartialPermissions from '../PartnerNewpluginsdkActivate/PartnerNewPluginActivateMultiStepPartialPermissions';
import PartnerNewPluginActivateMultiStepAllDone from '../PartnerNewpluginsdkActivate/PartnerNewPluginActivateMultiStepAllDone';
import AndroidAccessibility from '../AndroidAccessibility';
import PartnerPluginActivateV2 from '../PartnerPluginActivateV2';
import OfferWall from '../OfferWall';
import TIMActivationHome from '../TIM';
import EonPluginActivation from '../EonPluginActivation';
import EonPluginActivationAlwaysAllow from '../EonPluginActivation/EonPluginActivationAlwaysAllow';
import EonPluginActivationMultiStep from '../EonPluginActivation/EonPluginActivationMultiStep';
import EonPluginActivationStartShopping from '../EonPluginActivation/EonPluginActivationStartShopping';
import EonPluginActivationPartialPermissions from '../EonPluginActivation/EonPluginActivationPartialPermissions';
import EonPluginActivationAndroidAccessibility from '../EonPluginActivation/EonPluginActivationAndroidAccessibility';
import NTVPluginActivationHome from '../NTVPluginActivation';
import NTVPluginActivateMultiStep from '../NTVPluginActivation/NTVPluginActivationMultiStep';
import NTVPluginActivationAlwaysAllow from '../NTVPluginActivation/NTVPluginActivationAlwaysAllow';
import NTVPluginActivationPartialPermissions from '../NTVPluginActivation/NTVPluginActivationPartialPermissions';
import NTVPluginActivationStartShopping from '../NTVPluginActivation/NTVPluginActivationStartShopping';
import NTVPluginActivationAndroidAccessibility from '../NTVPluginActivation/NTVPluginActivationAndroidAccessibility';
import NTVPluginActivationAlternateBrowser from '../NTVPluginActivation/NTVPluginActivationAlternateBrowser';
import KindredPluginActivationHome from '../KindredPluginActivation';
import KindredPluginActivationPartialPermissions from '../KindredPluginActivation/KindredPluginActivationPartialPermissions';
import KindredPluginActivationSuccess from '../KindredPluginActivation/KindredPluginActivationSuccess';
import KindredPluginActivationAndroidAccessibility from '../KindredPluginActivation/KindredPluginActivationAndroidAccessibility';
import KindredPluginActivationAndroidInstructions from '../KindredPluginActivation/KindredPluginActivationAndroidInstructions';
import KindredPluginActivationAlternateBrowser from '../KindredPluginActivation/KindredPluginActivationAlternateBrowser';
import BlueLightCardPluginActivationHome from '../BlueLightCardPluginActivation';
import BlueLightCardPluginActivationMultiStep from '../BlueLightCardPluginActivation/BlueLightCardPluginActivationMultiStep';
import BlueLightCardPluginActivationAlwaysAllow from '../BlueLightCardPluginActivation/BlueLightCardPluginActivationAlwaysAllow';
import BlueLightCardPluginActivationPartialPermissions from '../BlueLightCardPluginActivation/BlueLightCardPluginActivationPartialPermissions';
import BlueLightCardPluginActivationStartShopping from '../BlueLightCardPluginActivation/BlueLightCardPluginActivationStartShopping';
import BlueLightCardPluginActivationAndroidAccessibility from '../BlueLightCardPluginActivation/BlueLightCardPluginActivationAndroidAccessibility';
import TIMAndroidAccessibility from '../TIM/AndroidAccessibility';
import PartnerNewpluginsdkActivateTim from '../PartnerNewpluginsdkActivateTim';
import PartnerNewPluginActivateTimMultiStepAlwaysAllow from '../PartnerNewpluginsdkActivateTim/PartnerNewPluginActivateTimMultiStepAlwaysAllow';
import PartnerNewPluginActivateTimMultiStepPartialPermissions from '../PartnerNewpluginsdkActivateTim/PartnerNewPluginActivateTimMultiStepPartialPermissions';
import PartnerNewPluginActivateTimMultiStepAllDone from '../PartnerNewpluginsdkActivateTim/PartnerNewPluginActivateTimMultiStepAllDone';
import DesktopExtensionLanding from '../ExtensionV2/Landing';
import ExtensionInstalledV2 from '../ExtensionV2/ExtensionInstalled';
import NationalRailExtensionInstalled from '../NationalRailDesktopActivation/ExtensionInstalled';
import NationalRailLanding from '../NationalRailDesktopActivation/Landing';

const StyledLoadingIndicator = styled(LoadingIndicator)`
  min-height: 1500px;
`;

const Routes = () => (
  <Suspense fallback={<StyledLoadingIndicator />}>
    <ScrollToTop />
    <RouterRoutes>
      <Route
        path={Path.KeyboardInstallationGuide}
        element={<KeyboardInstallationGuide />}
      />
      <Route
        path={Path.AndroidKeyboardInstallationGuide}
        element={<AndroidKeyboardInstallationGuide />}
      />
      <Route
        path={Path.PluginActivation}
        element={<PartnerpluginsdkActivate />}
      />
      <Route
        path={Path.PluginActivationV2ActivatePlugin}
        element={<PartnerNewpluginsdkActivate />}
      />
      <Route
        path={Path.TimPluginActivationActivatePlugin}
        element={<PartnerNewpluginsdkActivateTim />}
      />
      <Route
        path={Path.TimPluginActivationAlwaysAllow}
        element={<PartnerNewPluginActivateTimMultiStepAlwaysAllow />}
      />
      <Route
        path={Path.TimPluginActivationPartialPermissions}
        element={<PartnerNewPluginActivateTimMultiStepPartialPermissions />}
      />
      <Route
        path={Path.TimPluginActivationStartShopping}
        element={<PartnerNewPluginActivateTimMultiStepAllDone />}
      />
      <Route
        path={Path.TimPluginActivationAndroidStartShopping}
        element={
          <PartnerNewPluginActivateTimMultiStepAllDone platform="android" />
        }
      />
      <Route
        path={Path.EonPluginActivationHome}
        element={<EonPluginActivation />}
      />
      <Route
        path={Path.EonPluginActivationMultiStep}
        element={<EonPluginActivationMultiStep />}
      />
      <Route
        path={Path.EonPluginActivationAlwaysAllow}
        element={<EonPluginActivationAlwaysAllow />}
      />
      <Route
        path={Path.EonPluginActivationStartShopping}
        element={<EonPluginActivationStartShopping />}
      />
      <Route
        path={Path.EonPluginActivationPartialPermissions}
        element={<EonPluginActivationPartialPermissions />}
      />
      <Route
        path={Path.EonPluginAndroidAccessibility}
        element={<EonPluginActivationAndroidAccessibility />}
      />
      <Route
        path={Path.NTVPluginActivationHome}
        element={<NTVPluginActivationHome />}
      />
      <Route
        path={Path.NTVPluginActivationMultiStep}
        element={<NTVPluginActivateMultiStep />}
      />
      <Route
        path={Path.NTVPluginActivationAlwaysAllow}
        element={<NTVPluginActivationAlwaysAllow />}
      />
      <Route
        path={Path.NTVPluginActivationStartShopping}
        element={<NTVPluginActivationStartShopping />}
      />
      <Route
        path={Path.NTVPluginAndroidAccessibility}
        element={<NTVPluginActivationAndroidAccessibility />}
      />
      <Route
        path={Path.NTVPluginActivationPartialPermissions}
        element={<NTVPluginActivationPartialPermissions />}
      />
      <Route
        path={Path.NTVPluginActivationAlternateBrowser}
        element={<NTVPluginActivationAlternateBrowser />}
      />
      <Route
        path={Path.KindredPluginActivationHome}
        element={<KindredPluginActivationHome />}
      />
      <Route
        path={Path.KindredPluginActivationSuccess}
        element={<KindredPluginActivationSuccess />}
      />
      <Route
        path={Path.KindredPluginAndroidAccessibility}
        element={<KindredPluginActivationAndroidAccessibility />}
      />
      <Route
        path={Path.KindredPluginAndroidInstructions}
        element={<KindredPluginActivationAndroidInstructions />}
      />
      <Route
        path={Path.KindredPluginActivationPartialPermissions}
        element={<KindredPluginActivationPartialPermissions />}
      />
      <Route
        path={Path.KindredPluginActivationAlternateBrowser}
        element={<KindredPluginActivationAlternateBrowser />}
      />
      <Route
        path={Path.BlueLightCardPluginActivationHome}
        element={<BlueLightCardPluginActivationHome />}
      />
      <Route
        path={Path.BlueLightCardPluginActivationMultiStep}
        element={<BlueLightCardPluginActivationMultiStep />}
      />
      <Route
        path={Path.BlueLightCardPluginActivationAlwaysAllow}
        element={<BlueLightCardPluginActivationAlwaysAllow />}
      />
      <Route
        path={Path.BlueLightCardPluginActivationStartShopping}
        element={<BlueLightCardPluginActivationStartShopping />}
      />
      <Route
        path={Path.BlueLightCardPluginAndroidAccessibility}
        element={<BlueLightCardPluginActivationAndroidAccessibility />}
      />
      <Route
        path={Path.BlueLightCardPluginActivationPartialPermissions}
        element={<BlueLightCardPluginActivationPartialPermissions />}
      />
      <Route path={Path.SamsungLanding} element={<SamsungLanding />} />
      <Route path={Path.SamsungActivation} element={<SamsungActivation />} />
      <Route path={Path.TIMActivationHome} element={<TIMActivationHome />} />
      <Route path={Path.TIMHomePage} element={<TIMActivationHome />} />
      <Route
        path={Path.TIMAndroidActivationHome}
        element={<TIMAndroidAccessibility />}
      />
      <Route path={Path.ExtensionInstalled} element={<ExtensionInstalled />} />
      <Route
        path={Path.ExtensionUninstalled}
        element={<ExtensionUninstalled />}
      />
      <Route path={Path.DesktopLanding} element={<DesktopExtensionLanding />} />
      <Route
        path={Path.ExtensionInstalledV2}
        element={<ExtensionInstalledV2 />}
      />
      <Route
        path={Path.NationalRailExtensionInstalled}
        element={<NationalRailExtensionInstalled />}
      />
      <Route
        path={Path.NationalRailLanding}
        element={<NationalRailLanding />}
      />
      <Route path={`${Path.TreePlanting}`} element={<TreePlanting />} />
      <Route path={`${Path.EtisalatOfferWall}`} element={<OfferWall />} />
      <Route
        path={`${Path.EtisalatOfferWallArabic}`}
        element={<OfferWall documentDir="rtl" />}
      />
      <Route
        path={`${Path.PluginActivationV2}`}
        element={<PartnerPluginActivateV2 />}
      />
      <Route
        path={`${Path.PluginActivationReviewPermissionsV2}`}
        element={<AndroidAccessibility />}
      />
      <Route
        path={Path.PluginActivationReviewPermissions}
        element={<PartnerPluginActivateMultiStepAlwaysAllow />}
      />
      <Route
        path={Path.PluginActivationV2AlwaysAllow}
        element={<PartnerNewPluginActivateMultiStepAlwaysAllow />}
      />
      <Route
        path={Path.PluginActivationV2PartialPermissions}
        element={<PartnerNewPluginActivateMultiStepPartialPermissions />}
      />
      <Route
        path={Path.PluginActivationV2StartShopping}
        element={<PartnerNewPluginActivateMultiStepAllDone />}
      />
      <Route
        path={Path.PluginActivationAllowPermissions}
        element={<PartnerPluginActivateMultiStepAlmostThere />}
      />
      <Route
        path={Path.PluginActivationUpdatePermissions}
        element={<PartnerPluginActivateMultiStepBeSureToAllow />}
      />
      <Route
        path={Path.PluginActivationStartShopping}
        element={<PartnerPluginActivateMultiStepStartShopping />}
      />

      {/* Routes with DefaultLayout (header/footer) */}
      <Route element={<DefaultLayout />}>
        <Route path={Path.Home} element={<LinkRedirect />} />
        <Route
          path={Path.UnderTheHood}
          element={<LinkRedirect path="/kindred-faqs" />}
        />
        <Route path={Path.Network} element={<LinkRedirect />} />
        <Route
          path={Path.AboutUs}
          element={<LinkRedirect path="/about-us" />}
        />
        <Route path={Path.Loyalty} element={<LinkRedirect />} />
        <Route path={Path.Revenue} element={<LinkRedirect />} />
        <Route path={Path.ESG} element={<LinkRedirect />} />
        <Route path={Path.ProductHome} element={<LinkRedirect />} />
        <Route path={Path.ProductExtension} element={<LinkRedirect />} />
        <Route path={Path.Gaming} element={<LinkRedirect />} />
        <Route path={Path.ProductDesktop} element={<LinkRedirect />} />
        <Route path={Path.ProductApi} element={<LinkRedirect />} />
        <Route
          path={Path.ChromeExtensionDownload}
          element={<ChromeDesktopUTMTracking />}
        />

        {/* Redirects */}
        <Route
          path={Path.MobileGame}
          element={<Navigate to={Path.Gaming} replace />}
        />
        <Route
          path={Path.CharitiesWithAnApp}
          element={<Navigate to={Path.ESG} replace />}
        />
        <Route
          path={Path.Cashback}
          element={<Navigate to={Path.Revenue} replace />}
        />
        <Route
          path={Path.MobileApp}
          element={<Navigate to={Path.Home} replace />}
        />
        <Route
          path={Path.MobileNetwork}
          element={<Navigate to={Path.Home} replace />}
        />
        <Route
          path={Path.Keyboard}
          element={<Navigate to={Path.ProductHome} replace />}
        />

        {/* 404 fallback */}
        <Route path="*" element={<NotFound />} />
      </Route>
    </RouterRoutes>
  </Suspense>
);

export default Routes;
